import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16 0H10V2H13.071L7 8.07104L8.41422 9.48526L14 3.89948V6H16V0Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7 2H0V16H14V9H12V14H2V4H7V2Z",
		fill: "currentColor"
	})]
});
export default SvgExternalLink;
